<template>
    <div class="trip-convoy-cell">
        <button
            v-if="hasConvoy"
            type="button"
            class="btn btn-link p-0 d-inline-flex align-items-center justify-content-center trip-convoy-cell__button"
            :title="$t('view_convoy')"
            @click.prevent="openConvoyModal"
        >
            <app-icon name="eye" class="size-18" />
        </button>
        <span v-else class="trip-convoy-cell__placeholder">...</span>

        <convoy-add-edit-modal
            v-if="isConvoyModalActive"
            :selected-url="convoyUrl"
            :selected-trips="[]"
            :read-only="true"
            :trip-table-id="tableId"
            convoy-table-id="convoys-table"
            @close-modal="closeConvoyModal"
        />
    </div>
</template>

<script>
import * as actions from '../../../Config/ApiUrl';

export default {
    name: 'TripConvoyCell',
    props: {
        rowData: {
            type: Object,
            required: true,
        },
        tableId: {
            type: String,
            default: 'trips-table',
        },
    },
    data() {
        return {
            isConvoyModalActive: false,
        };
    },
    computed: {
        hasConvoy() {
            return Boolean(this.rowData?.convoy_id);
        },
        convoyUrl() {
            return this.hasConvoy ? `${actions.CONVOY}/${this.rowData.convoy_id}` : '';
        },
    },
    methods: {
        openConvoyModal() {
            if (!this.hasConvoy) {
                return;
            }

            this.isConvoyModalActive = true;
        },
        closeConvoyModal() {
            this.isConvoyModalActive = false;
        },
    },
}
</script>

<style scoped>
.trip-convoy-cell {
    min-height: 1.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.trip-convoy-cell__button {
    color: var(--brand-color, #ff7a18) !important;
}

.trip-convoy-cell__placeholder {
    color: #8a94a6;
    letter-spacing: 0.08em;
    font-weight: 600;
}
</style>
